import { CaseStudyPage, type CaseStudyData } from "@/components/CaseStudyTemplate";
import { CheckCircle, TrendingUp, Smartphone, PartyPopper } from "lucide-react";

const data: CaseStudyData = {
  seoTitle: "South Core Roar Case Study | Event Platform & Custom App | Frayze",
  seoDescription: "See how Frayze powers South Core Roar with a custom event app, vendor and sponsorship management, and marketing for Thunder Bay's premier car and motorcycle show.",
  seoKeywords: "event platform Thunder Bay, car show app, motorcycle show event system, Thunder Bay events, Fort William event marketing",
  canonical: "https://frayze.ca/case-studies/south-core-roar-event-platform/",
  breadcrumbs: [
    { name: "Home", item: "https://frayze.ca/" },
    { name: "Case Studies", item: "https://frayze.ca/case-studies/" },
    { name: "South Core Roar", item: "https://frayze.ca/case-studies/south-core-roar-event-platform/" },
  ],

  industry: "Events",
  industryColor: "rose",
  clientName: "South Core Roar",
  headline: (
    <>
      Complete <span className="text-rose-400">Event Platform</span> & Custom App for Thunder Bay's <span className="text-rose-400">Premier Car & Motorcycle Show</span>
    </>
  ),
  stats: [
    { value: "Custom", label: "Mobile App" },
    { value: "2026", label: "Launch Year" },
    { value: "Fort William", label: "District" },
    { value: "Full", label: "Event System" },
  ],

  client: "South Core Roar",
  industryLabel: "Events / Entertainment",
  location: "Thunder Bay, ON (Fort William)",
  services: "Event Platform, Custom App, Marketing",
  website: "southcoreroar.com",

  sections: [
    {
      title: "The Project",
      content: "South Core Roar is an upcoming motorcycle show, car show, live music event, and tourism experience launching in Thunder Bay's Fort William Business District in September/October 2026. It's designed to be the premier automotive and entertainment event in Northwestern Ontario (featuring vendors, exhibitors, prizes, licensed areas, and a custom mobile app).",
    },
    {
      title: "What We're Building",
      content: "Frayze is building the complete digital infrastructure to launch, promote, and operate South Core Roar as a professional, large-scale event.",
    },
    {
      title: "1. Custom Mobile App",
      content: "A dedicated event app with real-time schedule updates, vendor maps, show floor navigation, prize tracking, push notifications, and social sharing. Attendees will have everything they need in their pocket, and organizers will have a direct communication channel to every participant.",
    },
    {
      title: "2. Event Marketing Platform",
      content: "We're building the full marketing stack (event website, email campaigns, social media strategy, ticketing integration, and sponsorship/vendor acquisition funnels). Every touchpoint is designed to drive ticket sales and vendor sign-ups.",
    },
    {
      title: "3. Vendor & Sponsorship Management",
      content: "A structured system for managing vendor applications, sponsor packages, exhibitor registration, and event logistics. Sponsors get branded visibility through the app, website, and event signage (all tracked and measurable).",
    },
    {
      title: "4. Fort William Business District Feature",
      content: "The event is deeply tied to the Fort William Business Improvement Area (FWBIA). We're integrating local business promotions, district maps, and cross-promotion opportunities so the event drives foot traffic to the entire neighbourhood, not just the show floor.",
    },
  ],

  results: [
    { icon: Smartphone, label: "Custom Event App", sublabel: "Real-time schedule, maps, notifications, and social" },
    { icon: PartyPopper, label: "Full Event System", sublabel: "Ticketing, vendors, sponsors, and marketing all integrated" },
    { icon: TrendingUp, label: "Tourism & Economic Impact", sublabel: "Designed to attract visitors from across NWO" },
    { icon: CheckCircle, label: "Community Integration", sublabel: "Fort William Business District showcase" },
  ],

  stack: ["Custom Mobile App", "Event Website", "Email Campaigns", "Ticketing Integration", "Vendor Management System", "Sponsorship Funnels", "Push Notifications"],
};

const SouthCoreRoar = () => <CaseStudyPage data={data} />;
export default SouthCoreRoar;
